import classnames from "classnames";
import { Link } from "react-router-dom";
import { Badge, Card, CardBody, CardText } from "reactstrap";
import { useTranslation } from "react-i18next";
import { BiTimeFive } from "react-icons/bi";
import { BsCalendarDate, BsMusicNoteList } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Play } from "react-feather";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction.js";
import { FaUserTie } from "react-icons/fa";
import { TbLanguage } from "react-icons/tb";
import { BsFillTagsFill } from "react-icons/bs";
import { MdCategory } from "react-icons/md";
import { BsPenFill } from "react-icons/bs";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { FaEye } from "react-icons/fa";

const API = process.env.REACT_APP_MICRO_PLANING_URL;
const shareUrl = `${API}/emission`;

const EpisodeCards = (props) => {
  const { datas, activeView, data } = props;
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const formatDate = (date) => {
    const dateToFormat = new Date(date);
    return `${dateToFormat.getDate()}-${
      dateToFormat.getMonth() + 1
    }-${dateToFormat.getFullYear()}`;
  };

  const formatTime = (date) => {
    const dateToFormat = new Date(date);
    return `${dateToFormat.getHours()}:${dateToFormat.getMinutes()}:${dateToFormat.getSeconds()}`;
  };

  const renderdata = () => {
    if (data?.length) {
      return data?.map((item, i) => {
        return (
          <Card
            className="ecommerce-card"
            key={item.id}
            style={{ gridTemplateColumns: "2fr 2fr 1fr" }}
          >
            <div className="item-img text-center mx-auto">
              <Link to={`/emission/${item.id}`}>
                <img
                  width="100%"
                  height="100%"
                  className="img-fluid card-img-top"
                  src={item.emission.picture}
                  alt={item.emission.picture}
                />
              </Link>
            </div>
            <CardBody>
              <h6 className="item-name">
                <Link to={`/emission/${item.id}`}>{item.name}</Link>
              </h6>
              <CardText className="item-description" tag="div">
                <p>
                  {" "}
                  {t("Description :")} {item.description}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <p>
                  {t("Category")} : {item.categorie?.name}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <p>
                  {" "}
                  {t("Classification")} : {item.classification?.name}
                </p>
              </CardText>{" "}
              <CardText className="item-description" tag="div">
                <p>
                  {" "}
                  <BsPenFill /> {t("columnist")} :
                  {item.columnist?.map((ele, i) => (
                    <Badge color="light-info">{ele.first_name}</Badge>
                  ))}
                </p>
              </CardText>{" "}
              <CardText className="item-description" tag="div">
                <p>
                  {" "}
                  <FaUserTie /> {t("guestes")} :{" "}
                  {item.guest?.map((ele, i) => (
                    <Badge color="light-primary">{ele.first_name}</Badge>
                  ))}
                </p>
              </CardText>{" "}
              <CardText className="item-description" tag="div">
                <p>
                  <BsCalendarDate /> {t("date start")} :{" "}
                  {formatDate(item.episode_schedule[0]?.start_datetime)}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <p>
                  <BiTimeFive /> {t("time start")} :{" "}
                  {formatTime(item.episode_schedule[0]?.start_datetime)}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <p>
                  <TbLanguage /> {t("Language")} : {item.language?.name}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <p>
                  <BsFillTagsFill /> {t("Tags :")}
                  {item.tags?.map((el, i) => (
                    <Link to={`/episode/tag/${el.slug}`}>
                      <Badge
                        style={{ fontSize: "10px" }}
                        className="ms-1"
                        color="light-secondary"
                        pill
                        key={i}
                      >
                        #{el.name}
                      </Badge>
                    </Link>
                  ))}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <p>
                  <MdCategory /> {t("categories")} :
                  {item.categories?.map((el, i) => (
                    <Link to={`/episode/category/${el.slug}`}>
                      <Badge
                        className="ms-1"
                        style={{ fontSize: "10px" }}
                        color="light-warning"
                        pill
                        key={i}
                      >
                        {el.name}
                      </Badge>
                    </Link>
                  ))}
                </p>
              </CardText>
              <CardText className="item-description" tag="div">
                <div className="item-wrapper episode">
                  {item.status_id == 3 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: "10px",
                        justifyContent: "space-around",
                      }}
                    >
                      {PlayerFrontOfficeReducer?.currentSong ===
                      item.podcast?.file_path ? (
                        <div>
                          {<BsMusicNoteList size={20} />}
                          {t("playing")}
                        </div>
                      ) : (
                        <div
                          onClick={() =>
                            dispatch(
                              addMusic({
                                currentsong: item.podcast?.file_path,
                                download: `${API}/podcast/download/${item.id}`,
                                namesong: `${item.podcastname}`,
                                is_web_rtc: false,
                                has_video: item.name.endsWith("mp4") && true,
                              })
                            )
                          }
                        >
                          <Play
                            size={20}
                            className="pointer_cursor "
                            id="Play"
                            color="#A8ECE7"
                          />
                          {t("poadcast")} :
                        </div>
                      )}

                      <Badge
                        className="text-capitalize"
                        style={{
                          width: "150px",
                          marginLeft: "5px",
                        }}
                        color="light-danger"
                        pill
                      >
                        {t("finished")}
                      </Badge>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: "10px",
                        justifyContent: "space-around",
                      }}
                    >
                      <Badge
                        className="text-capitalize"
                        style={{ width: "80px" }}
                        color="light-success"
                        pill
                      >
                        {t("comming")}
                      </Badge>
                    </div>
                  )}
                </div>
              </CardText>
              {/* <CardText className="item-description" tag="div">
                <p>Created by : {item.user_id}</p>
              </CardText> */}
              {/* <CardText className="item-description" tag="div"><p>{t("Number Episode")} : 2</p></CardText> */}
              <div className="item-cost">
                <h6 className="item-price">
                  <CardText tag="div">
                    <ul
                      className="blog-icon-podcast"
                      style={{ textAlign: "center" }}
                    >
                      <li>
                        <FacebookShareButton url={`${shareUrl}${item.id}`}>
                          <FacebookIcon size={30} round={true} />
                        </FacebookShareButton>
                      </li>

                      <li>
                        <TwitterShareButton url={`${shareUrl}${item.id}`}>
                          <TwitterIcon size={30} round={true} />
                        </TwitterShareButton>
                      </li>
                      <li>
                        <WhatsappShareButton url={`${shareUrl}${item.id}`}>
                          <WhatsappIcon size={30} round={true} />
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <FacebookMessengerShareButton
                          url={`${shareUrl}${item.id}`}
                        >
                          <FacebookMessengerIcon size={30} round={true} />
                        </FacebookMessengerShareButton>
                      </li>
                    </ul>
                  </CardText>
                </h6>
              </div>
            </CardBody>
            <div className="item-options text-center">
              <h4 className="item-price">
                <div
                  className="text-center mx-auto cursor-pointer me-50 py-50"
                  style={{ flexDirection: "row" }}
                >
                  <Link
                    to={`/emission/${item.id}`}
                    style={{ marginRight: "5px" }}
                  >
                    <FaEye
                      style={{ display: "inline !important" }}
                      size={20}
                      id="Show"
                    />
                  </Link>
                </div>
                <CardText tag="div">
                  <ul
                    className="blog-icon-podcast"
                    style={{ textAlign: "center" }}
                  >
                    <li>
                      <FacebookShareButton url={`${shareUrl}${item.id}`}>
                        <FacebookIcon size={30} round={true} />
                      </FacebookShareButton>
                    </li>

                    <li>
                      <TwitterShareButton url={`${shareUrl}${item.id}`}>
                        <TwitterIcon size={30} round={true} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton url={`${shareUrl}${item.id}`}>
                        <WhatsappIcon size={30} round={true} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookMessengerShareButton
                        url={`${shareUrl}${item.id}`}
                      >
                        <FacebookMessengerIcon size={30} round={true} />
                      </FacebookMessengerShareButton>
                    </li>
                  </ul>
                </CardText>
              </h4>
            </div>
          </Card>
        );
      });
    }
  };

  return (
    <div
      className={classnames({
        "grid-view": activeView === "grid",
        "list-view": activeView === "list",
      })}
    >
      {renderdata()}
    </div>
  );
};

export default EpisodeCards;
